<template lang="pug">
DropdownCheckboxes(
  :label="label"
  :name="name"
  :options="subsiteOptions"
  :value="value"
  @input="update"
  :loading="loading"
  v-if="multipleOptions"
)
</template>

<script>
  import { mapStores } from 'pinia'
  import { useSubsitesStore } from '@/stores/subsites'
  import DropdownCheckboxes from '@/components/dropdown_checkboxes.vue'

  export default {
    components: {
      DropdownCheckboxes
    },

    props: {
      label: {
        type: String,
        default() { return 'Subsite' }
      },

      name: {
        type: String,
        default() { return 'q[subsite_ids_in][]' }
      },

      value: {
        type: Array,
        default() { return [] }
      }
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(useSubsitesStore),

      subsiteOptions() {
        return this.subsitesStore.asObject
      },

      multipleOptions() {
        return this.subsitesStore.subsites.length > 1
      }
    },

    async mounted() {
      await this.subsitesStore.fetchOnce()

      this.loading = false
    },

    methods: {
      update(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
</script>
